import DocumentConfiguration from '../../../document/pages/Configuration';
import * as DocumentQueries from './queries.tsx';
import { GET_OVERVIEW_DATA } from '../queries.ts';
import { CHANNEL_CONFIG_PATH, CHANNEL_PATH, OVERVIEW_PATH } from '../constants.ts';
import React from 'react';
import { DocumentType } from '../../../document/constants.ts';
import { DocumentTypeName, ValidationCheck } from '../../../document/components/DocumentConfig.tsx';

const Configuration = (props) => {
    const documentConfiguration = {
        service: 'rfqs',
        documentType: DocumentType.Rfq,
        documentTypeName: 'rfq',
        activeTab: 'rfq',
        documentQueries: DocumentQueries,
        getOverviewData: GET_OVERVIEW_DATA,
        channelPath: CHANNEL_PATH,
        overviewPath: OVERVIEW_PATH,
        configPath: CHANNEL_CONFIG_PATH,
        documentTypes: [
            DocumentTypeName.DeliveryNote,
            DocumentTypeName.Invoice,
            DocumentTypeName.Offer,
            DocumentTypeName.Order,
            DocumentTypeName.OrderConfirmation,
            DocumentTypeName.RequestForQuotation,
        ],
        validationChecks: [
            ValidationCheck.ThousandSeparatorQuantity,
            ValidationCheck.ForgottenLineItems,
            ValidationCheck.IncompleteLineItems,
            ValidationCheck.CustomerInternalNote,
            ValidationCheck.MaxQuantity,
            ValidationCheck.MinQuantity,
            ValidationCheck.RepeatedLineItems,
            ValidationCheck.ArticleDescriptionCheck,
            ValidationCheck.ArticleStatus,
            ValidationCheck.UniqueDocumentNumber,
        ],
    };

    return <DocumentConfiguration documentConfiguration={documentConfiguration} {...props} />;
};

export default Configuration;
